import angular from 'angular';

var SECURITY_HIDDEN_CLASS = 'no-access-configuration';

// example: allowed for tenant config 0 or 1 or if tenant has feature 32 cx-tenant-configuration="[0,1;32]"

angular.module('cloudX').directive('cxTenantConfigurationOrFeature', [
  '$rootScope',
  'checkTenantConfiguration',
  'authService',
  'checkFeature',
  function($rootScope, checkTenantConfiguration, authService, checkFeature) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var security = '';
        var feature = '';
        var doCheck = function() {
          if (checkTenantConfiguration(security) || checkFeature(feature))
            element.removeClass(SECURITY_HIDDEN_CLASS);
          else element.addClass(SECURITY_HIDDEN_CLASS);
        };

        attr.$observe('cxTenantConfiguration', function() {
          security = attr.cxTenantConfiguration.split(';')[0];
          feature = attr.cxTenantConfiguration.split(';')[1];
          doCheck();
        });

        var destroyer = $rootScope.$on('$cxAuthenticated', function() {
          doCheck();
        });
        scope.$on('$destroy', function() {
          destroyer();
        });

        authService.addOnNewToken(function(token) {
          doCheck();
        });
      },
    };
  },
]);
